
import { gapiCall } from './gapi';

// product request action types
export const REQUEST_PRODUCTS = "REQUEST_PRODUCTS";
export const REQUEST_PRODUCTS_SUCCESS = "REQUEST_PRODUCTS_SUCCESS";
export const REQUEST_PRODUCTS_ERROR = "REQUEST_PRODUCTS_ERROR";

// sets current product (side menu display)
export const SET_CURRENT_PRODUCT = "SET_CURRENT_PRODUCT";

// sets plan product target periodicity used to display monthly or yearly plan
export const TARGET_PLAN_PERIODICITY ="TARGET_PLAN_PERIODICITY";

export const PERIODICITY = {
  MONTHLY: 1,
  YEARLY: 12
}

/** 
 * List products action creator
*/
const requestProducts = () => {
  return {
    type: REQUEST_PRODUCTS
  }
}

/**
 * List products success action creator
 * @param {Array} items Array of all products, with plans
 */
const requestProductsSuccess = (items) => {
  return {
    type: REQUEST_PRODUCTS_SUCCESS,
    items
  }
}

/**
 * List products error action creator
 * @param {Error} error 
 */
const requestProductsError = (error) => {
  return {
    type: REQUEST_PRODUCTS_ERROR,
    error
  }
}

/**
 * Sets the current product to "productId"
 */
export const setCurrentProduct = productId => ({
  type: SET_CURRENT_PRODUCT,
  productId,
});

/**
 * Sets the plan target periodicity (1 for monthly and 12 for yearly) related to the plan display on Product Page
 * @param {Integer} periodicity 
 */
export const setTargetPlanPeriodicity = periodicity => ({
  type: TARGET_PLAN_PERIODICITY,
  periodicity
})

/**
 * Generates the session storage key that stores the redirect URL back to
 * a product (see ProductPage)
 * @param {Object} product 
 */
const productRedirectKey = product => 'redirect.' + product.id;


// FIXME: handle product redirect in store
// FIXME: handle invalidation
/**
 * Stores product redirect url in session storage
 * The passed URL is stored only if it starts with the product url
 * @param {Object} product 
 * @param {String} url The url to redirect back to the product
 */
export const setProductRedirect = (product, url) => {
  if (url && url.indexOf(product.url) === 0) {
    window.sessionStorage.setItem(productRedirectKey(product), url);
  }
}

/**
 * Gets the URL to redirect back to the product in session storage
 * @param {Object} product 
 */
export const getProductRedirect = (product) =>
  window.sessionStorage.getItem(productRedirectKey(product));

/** 
 * Fetches the list of products from the API 
 */
export const fetchProducts = () => dispatch =>
  dispatch(requestProducts())
  && dispatch(gapiCall(client => client.billing.products.list()))
    .then(result => dispatch(requestProductsSuccess(result.items)))
    .catch(error => dispatch(requestProductsError(error)))

/**
 * Navigates to the product.
 * Navigates to the redirect stored in local storage, or to the product url
 * @param {Object} product 
 */
// FIXME: should be thunk (product => dispatch => ...)
export const doNavigateToProduct = product => {
  const redirect = getProductRedirect(product);
  document.location.href = redirect ? redirect : product.url;
}



// WEBPACK FOOTER //
// ./src/actions/products.js